import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { getPermissions } from "../rbac/hasAccess";
import { submitSiteDelete } from "../../utils/commonComponent/delete";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import ListView from "../../utils/commonComponent/Custom/listView";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { fetchQuery } from "../../utils/commonComponent/fetched";

const headers = ["id", "label", "value"];

const fields = [
  { value: "label", label: "Label" },
  { value: "value", label: "Description" },
];

const RemarkList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editRemark/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("remarks", row.id);

  const [remarkList, setRemarkList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "label");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  // 🔹 WHERE clause builder
  const getWhereClause = () => {
    const colMap = {
      label: "label",
      value: "value",
    };

    const colName = colMap[searchBy];
    const key = searchKey?.trim().toLowerCase();

    let whereConditions = [];

    if (colName && key) {
      whereConditions.push(`LOWER(${colName}) LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  // 🔹 DATA query with pagination
  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)
        }`;
    }

    return `SELECT * FROM remarks ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  // 🔹 COUNT query
  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM remarks ${whereClause};`;
  };

  // 🔹 Fetch data
  const fetchData = async () => {
    try {
      const [unitData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      setRemarkList(unitData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination total
    } catch (error) {
      console.error("Error fetching remark data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("label");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editRemark/0"
          label="Add Unit"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Remark"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={remarkList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"remarks"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default RemarkList;
